function setUpEditForm(id, firstName, lastName, countryId, email){
	var form = document.getElementById('rafForm');
	form.elements[0].value="updateraf"; // Edit flow
	form.elements[1].value=id;
	form.elements[2].value=email; // Original email
	form.elements[3].value=firstName;
	form.elements[4].value=lastName;
	var opts = document.getElementById('PARAM_COUNTRY');
	for (i=0;i<opts.length;i++){
		if(opts.options[i].value==countryId){
			opts.options[i].selected='yes';
			break;
		}
	}
	form.elements[6].value=email;	
	// Reset buttons
	var submitButtons = new YAHOO.util.Element('submitNewRafButtons');
	submitButtons.setStyle('display', 'none');
	var updateButtons = new YAHOO.util.Element('updateRafButtons');
	updateButtons.setStyle('display', 'block');
}

function sendRAF(){
	document.getElementById("rafForm").submit();
}
function deleteRAF(){
	document.getElementById("deleteRaf").submit();
}
function resetRAF(){
	var form = document.getElementById('rafForm');
	form.elements[0].value="submitraf"; // Submit flow
	form.elements[1].value="-1";
	form.elements[2].value="-1"; // Original email
	form.elements[3].value="";
	form.elements[4].value="";
	form.elements[6].value="";	
	// Reset buttons
	var updateButtons = new YAHOO.util.Element('updateRafButtons');
	updateButtons.setStyle('display', 'none');
	var submitButtons = new YAHOO.util.Element('submitNewRafButtons');
	submitButtons.setStyle('display', 'block');
	
	
}

// fix a problem of wrong reload page on ComeOn! Points page when
// next/previous buttons are pressed for chrome and safari browsers 
function fixChromeSafari() {
	if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || 
		navigator.userAgent.toLowerCase().indexOf('safari') > -1	 
	)
		location.reload();
}	;
define("legacy/loyalty", function(){});

